<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import EventSelection from './EventSelection.vue';

export default {
  name: 'EventCard',
  components: {
    EventSelection,
    RelativeTime,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    meeting: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    selections: {
      type: Array,
      required: false,
      default: () => [],
    },
    url: {
      type: String,
      required: true,
    },
    shortlist: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      endingSoon:
        moment
          .utc(this.date)
          .local()
          .diff(moment(), 'hours') < 1,
      hasSelections: this.selections.length > 0,
      localDate: moment
        .utc(this.date)
        .local()
        .format(),
      name: `${this.meeting} R${this.number}`,
      raceTime: moment
        .utc(this.date)
        .local()
        .format('h:mma'),
    };
  },
  computed: {
    ...mapGetters({
      getOdds: 'BestOdds/getSelectionOdds',
    }),
  },
  methods: {
    displayRunnerCard: function(selectionId) {
      this.$emit('displayRunnerCard', selectionId);
    },
    isShortlisted: function(selectionId) {
      return this.shortlist.includes(selectionId);
    },
    shortlistSelection: function(selectionId, method = 'add') {
      this.$emit('shortlistSelection', selectionId, method);
    },
    odds: function(id) {
      return this.getOdds(Number(id)) || {};
    },
  },
};
</script>
<template>
  <div v-if="hasSelections" class="form-result-group__event">
    <a :href="url" target="_blank">
      <h3>
        <span>{{ name }}</span>
        <relative-time v-if="endingSoon" :brand="`punters`" :target-time="localDate" />
        <div v-else>{{ raceTime }}</div>
      </h3>
    </a>
    <ol>
      <EventSelection
        v-for="selection in selections"
        :key="selection.id"
        :id="selection.id"
        :event-id="id"
        :competitor-url="selection.competitor.url"
        :name="selection.competitor.name"
        :number="selection.number"
        :barrier="selection.barrierNumber"
        :jockey-image-url="selection.silkUrl"
        :jockey-name-short="selection.jockey.nameShort"
        :jockey-url="selection.jockey.url"
        :trainer-name-short="selection.trainer.nameShort"
        :trainer-url="selection.trainer.url"
        :is-shortlisted="isShortlisted(selection.id)"
        :odds="odds(selection.id)"
        :weight="selection.weight.value"
        :last-six-figure="selection.statistics.lastSixStarts"
        @show="displayRunnerCard"
        @shortlistSelection="shortlistSelection"
      />
    </ol>
  </div>
</template>
